import * as React from 'react'
import { SVGProps } from 'react'

const SvgXidrLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M80 160c44.183 0 80-35.817 80-80S124.183 0 80 0 0 35.817 0 80s35.817 80 80 80Z"
      fill="#F21616"
    />
    <path
      d="M35.058 77.382c6.646-3.774 7.28-9.172 8.142-14.005.515-2.913.705-4.05.705-4.05H55.71s-.558 3.098-1.08 6.019c-.86 4.833-.705 8.353-7.154 12.036l-9.221 5.235c-6.646 3.768-7.281 9.172-8.142 14.005a544.17 544.17 0 0 0-.705 4.05H17.602l1.08-6.019c.853-4.832.705-8.353 7.154-12.036l9.22-5.235Z"
      fill="#fff"
    />
    <path
      d="M32.334 75.93h-4.797a8.255 8.255 0 0 1-8.17-6.739l-1.764-9.877h11.775l2.956 16.615ZM40.956 84.078h4.819a8.248 8.248 0 0 1 8.163 6.731l1.77 9.877H43.934l-2.977-16.608ZM68.21 94.35v-28.7h7.592v28.7h-7.591ZM84.946 94.35v-28.7h8.466a21.017 21.017 0 0 1 5.983.797c1.72.48 3.311 1.338 4.657 2.511a11.527 11.527 0 0 1 3.026 4.417 17.455 17.455 0 0 1 1.08 6.49 18.08 18.08 0 0 1-1.059 6.534 11.793 11.793 0 0 1-2.977 4.508 12.035 12.035 0 0 1-4.55 2.604c-1.85.573-3.779.857-5.715.84h-8.911Zm7.598-6.096h.466c.984.01 1.964-.117 2.914-.373a5.482 5.482 0 0 0 2.363-1.306 6.187 6.187 0 0 0 1.567-2.56c.424-1.341.62-2.744.578-4.15a12.13 12.13 0 0 0-.578-4.105 5.87 5.87 0 0 0-1.567-2.47 5.327 5.327 0 0 0-2.363-1.213 12.088 12.088 0 0 0-2.914-.332h-.437l-.029 16.51ZM114.825 94.35v-28.7h10.865a21.57 21.57 0 0 1 4.388.437c1.309.257 2.555.768 3.669 1.503a7.611 7.611 0 0 1 2.498 2.822 9.744 9.744 0 0 1 .924 4.48 9.574 9.574 0 0 1-1.256 5.122 8.93 8.93 0 0 1-3.379 3.182l6.222 11.126h-8.466l-4.939-9.623h-2.914v9.651h-7.612Zm7.598-15.634h2.738c3.062 0 4.593-1.265 4.593-3.796a2.758 2.758 0 0 0-1.171-2.56 6.711 6.711 0 0 0-3.422-.706h-2.738v7.062ZM133.077 111.008a61.452 61.452 0 0 1-106.154 0H22.04a65.74 65.74 0 0 0 115.918 0h-4.882ZM26.923 48.992a61.452 61.452 0 0 1 106.154 0h4.882a65.74 65.74 0 0 0-115.918 0h4.882Z"
      fill="#fff"
    />
  </svg>
)

export default SvgXidrLogo
